import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { RentriService } from '../../../services/rentri.service';
import { alert, confirm } from 'devextreme/ui/dialog';
import { DxDataGridComponent } from 'devextreme-angular';
import { NgxSpinnerService } from 'ngx-spinner';
import { ComponentService } from '../../../services/component.service';
import { FORMULARIO, DATIFORMULARIO, DATITRASPORTOPARTENZA, DATIACCETTAZIONE, messagefromComponent } from '../../../class/appinterface';
import { NicaFormComponent } from '../../../components/nica-form/nica-form.component';
import notify from 'devextreme/ui/notify';
import { ActivatedRoute, Router } from '@angular/router';
import { NicaMenuService } from '../../../services/nica-menu.service';
import { Console } from 'console';
import { AnagraficaService } from '../../../services/anagrafica.service';
import { OverlaySideFormService } from '../../../components/shared/overlay-side-form/overlay-side-form.service';
import { ContattiComponent } from '../../../components/contatti/contatti.component';


export class AziendaRentri {
  capSl: string;
  cciaa: string;
  civicoSl: string;
  denominazione: string;
  idComuneSl: string;
  idNazioneSl: string;
  identificativo: string;
  istatProvSl: string;
  localitaSl: string;
  numRea: string;
  pec: string;
  piva: string;
  profiloSoggetto: string;
  viaSl: string;
}

@Component({
  selector: 'app-formulari',
  templateUrl: './formulari-rentri.component.html',
  styleUrls: ['./formulari-rentri.component.css', '../../../components/nica-anagrafica/nica-anagrafica.component.style.css'],
  host: {
    '(document:click)': 'onClickOutsidenMenu($event)',
  },
})
export class FormulariRentriComponent implements OnInit {
  @ViewChild('rentriGrid', { static: false }) rentriGrid: DxDataGridComponent;
  @ViewChild('formulariForm', { static: false }) formulariForm: NicaFormComponent;
  @ViewChild('datiTrasporto', { static: false }) datiTrasporto: NicaFormComponent;

  @Input() itemData

  elencoFormulari: Object = [];
  elencoFormulariCopy: Object = [];
  elencoFormulariTbl: Object = [];
  detailFormulario: string;
  detailFormularioArray: Object = [];


  elencoUL: any = [];
  elencoNSSedi: any = [];
  idSedeSelected: any;
  selectedUL: any = [];
  stati: any = []
  azienda: AziendaRentri;
  /**FORM**/
  apicall: string;
  apicallDati: string;
  subjectCall: string;
  subjectCallDati: string;
  idUL: any;
  filterKey: any;
  filterKeyDati: any;
  heightFormFormulario: number;
  heightFormSingleTab: number = 630;
  buttonCustom: any[] = [];
  buttonCustomDati: any[] = [];
  datijson: any;
  datijsonDati: any;
  /**POPUP & ANTEPRIMA**/

  closeButtonOptions: any;
  widthPopup: number = 630;
  heightPopup: number = 600;
  popupVisible: boolean = false;
  fileName: string;
  embed: any;
  popupDatiTrasportoForm: boolean = false;

  /*****/

  openDMenu: boolean;
  filterButton: any[];
  selectBoxUL: any;
  fileDownloads: any[];
  selectBoxStati: { width: number; dataSource: Object; valueExpr: string; placeholder: string; showClearButton: boolean; displayExpr: string; onValueChanged: (val: any) => void; };
  optionButton: any;
  popupVisibleForm: boolean = false;
  dataset: any[];
  datiFormulario: any;
  datiProduttore: any;

  buttonDatiTrasporto: any[] = [];
  firmaButtonOptions: any;
  currentFirSelected: any;
  typeForm: string;

  queryString: string;
  menuColonna: any[];
  textButtonAction: any;
  queryParams: any
  denominazioneAzienda: any;
  returnUrl: string;
  nCol: number = 1;
  tabRentri: any[] = []
  constructor(
    private rentriService: RentriService,
    private anagraficaSerice: AnagraficaService,
    private sanitizer: DomSanitizer,
    private loader: NgxSpinnerService,
    private userComponentService: ComponentService,
    private _overlaySideFormService: OverlaySideFormService,
    private _overlaySidePanelService: OverlaySideFormService,
    private _eref: ElementRef,
    private activateRoute: ActivatedRoute,
    private router: Router,
    private menuService: NicaMenuService
  ) { }

  onClickOutsidenMenu(event) {

    let targetClass = event.target.className;
    let includes = targetClass.indexOf('anctionTemp') !== -1

    if (!includes) {

      this.openDMenu = false;

    }
  }

  ngOnInit() {







    this.menuService.previousUrl$.subscribe(prevUrl => {

      this.returnUrl = prevUrl
    })


    this.activateRoute.queryParams.subscribe(queryParams => {
      console.log('FormularioqueryParams:', queryParams)
      if (queryParams.infoAzienda) {
        this.azienda = JSON.parse(queryParams.infoAzienda)

      }

      if (queryParams.componentTemplate == 'griglia') {
        this.popupVisibleForm = false
      }

      if (queryParams.componentTemplate == 'form') {
        this.apicall = 'RentriOld/inviaFormulario';
        this.subjectCall = "formularioForm";

        this.typeForm = "tabbedStep";
        this.buttonCustom = []
        this.popupVisibleForm = true
      }

      if (queryParams.denominazioneAzienda) {
        this.denominazioneAzienda = queryParams.denominazioneAzienda
      }
      this.queryParams = queryParams
      this.tabRentri = [


        {
          name: 'Formulari',
          path: "main/rentri-formulari",
          disabled: false
        },
        {
          name: 'Movimenti',
          path: "main/rentri-movimenti",
          disabled: true
        },
      ]
    })

    if (this.itemData) {


      this.azienda = this.itemData[0].infoAzienda;

      console.log(this.azienda)
    }

    this.menuColonna = [
      { name: 'Anteprima PDF', icon: 'glyphicon icon-pdf', costantValue: '', value: 'previewxPDF', hint: 'Anteprima PDF' },
      { name: 'Scarica PDF', icon: 'glyphicon mdi mdi-file-download-outline', costantValue: '', value: 'downloadxPDF', hint: 'Scarica PDF' },
      { name: 'Modifica Formulario', icon: 'glyphicon mdi mdi-file-download-outline', costantValue: '', value: 'editFormulario', hint: 'Modifica fomulario' },


    ]

    let rentriCloudSedi;
    this.anagraficaSerice.getElenco('Sede/GetSediNsAziende').then(res => {

      this.elencoNSSedi = res['items'];

      console.log('rentriCloudSedi', rentriCloudSedi)
    })


    this.getFormulariElenco()


    this.selectBoxStati = {
      width: 350,
      dataSource: this.stati,
      valueExpr: 'stato',
      placeholder: 'Scegli stato formulario',
      showClearButton: true,
      displayExpr: 'statoDesc',

      onValueChanged: (val) => {


        this.elencoFormulariTbl = this.elencoFormulari;
        if (val.value) {


          this.filterToStato(this.elencoFormulariTbl, val.value);
          this.rentriGrid.instance.refresh()
        }
        //this.productsStore.load();
      },
    };


    //BottoneCrea

    this.optionButton = {

      text: 'Crea FIR',
      type: 'outlined',
      name: 'Crea FIR',
      icon: 'add',

      onClick: ($event) => {

        if (typeof this.idUL != 'undefined') {

          //alert(this.azienda.denominazione,'Azieda')
          this.datiFormulario = {
            idSede: this.idSedeSelected,
            identificativoSito: this.idUL
          }


          const navigationParams = {
            ...this.queryParams,
            infoAzienda: JSON.stringify(this.azienda),
            componentTemplate: 'form',

          }
          //const navigationParams = {...this.queryParmas, infoAzienda: JSON.stringify(this.infoAzienda[0])}

          this.router.navigate(
            ['main/rentri-formulari'],
            {
              queryParams: navigationParams,
              skipLocationChange: true,
              replaceUrl: false
            }
          ).then(re => {

          })



        } else {
          alert('<p>Scegli la sede!</p>', 'Attenzione')
        }



      }
    }



    //Unità Locali
    this.rentriService.getElencoSiti().then(unitaLocali => {




      this.unitaLocaliRender(unitaLocali)
    });


    this.closeButtonOptions = {
      stylingMode: 'text',
      icon: 'close',
      onClick: (e) => {
        this.destroyPreview(e)


      },
    }


    this.firmaButtonOptions = {
      icon: 'mdi mdi-grease-pencil',
      text: '',
      stylingMode: 'text',

      onClick: (e) => {
        this.buttonFirmaFormulario(e, this.currentFirSelected);
      },

    }


    this.fileDownloads = ['Scarica xfir', 'Scarica PDF'];



  }

  renderFilterButton(formulari) {
    this.filterButton = [
      {
        stylingMode: "text",
        text: "Formulari da Firmare Produttore",
        type: "normal",
        cssClass: 'rentriFilter',
        onClick: ($event) => {

          let stati = ['FirmaProduttore', 'FirmaProduttoreTrasportatorePartenza', 'InserimentoTrasportoPartenza']
          if (!$event.element.classList.contains('active_filter')) {
            this.changeFilter(1, stati, formulari);
            $event.element.classList.add('active_filter')
          } else {
            $event.element.classList.remove('active_filter');
            this.elencoFormulariTbl = this.elencoFormulari;
            console.log(this.elencoFormulari)
          }
        },
      },
      {
        stylingMode: "text",
        text: "Formulari Firmati",
        type: "normal",
        cssClass: 'rentriFilter',
        onClick: ($event) => {


          let stati = ['InserimentoDatiAccettazione', 'FirmaDatiAccettazione']

          if (!$event.element.classList.contains('active_filter')) {
            this.changeFilter(2, stati, formulari);
            $event.element.classList.add('active_filter')
          } else {
            $event.element.classList.remove('active_filter');
            console.log(this.elencoFormulari)
            this.elencoFormulariTbl = this.elencoFormulari
          }
        },
      },
      {
        stylingMode: "text",
        text: "In attesa di Firma del Trasportatore",
        type: "normal",
        cssClass: 'rentriFilter',
        onClick: ($event) => {

          let stati = ['FirmaTrasportoPartenza']
          if (!$event.element.classList.contains('active_filter')) {
            this.changeFilter(3, stati, formulari);
            $event.element.classList.add('active_filter')
          } else {
            $event.element.classList.remove('active_filter');
            console.log(this.elencoFormulari)
            this.elencoFormulariTbl = this.elencoFormulari
          }



        },
      }
    ];
  }



  unitaLocaliRender(unitaLocali: Object) {

    this.elencoUL = unitaLocali;

    this.selectBoxUL = {
      width: 350,


      dataSource: this.elencoUL,
      valueExpr: 'identificativo',
      placeholder: 'Scegli unità locale',
      showClearButton: true,
      displayExpr: 'nome',

      onValueChanged: (val) => {

        if (val.value) {
          this.idUL = val.value;



          this.selectedUL = this.elencoUL.filter(ul => {
            return ul.identificativo == val.value
          })




          const idSede = this.elencoNSSedi.filter(res => {
            return res.idSedeRentri == val.value
          })

          console.log('|||||||||||||idSede---->', idSede);

          this.idSedeSelected = idSede[0].idSede



          /*
             civic: null
            codiceRea:null
            comune:"POMPEI"
            dataCreazione:"2021-09-03T13:38:02.3762999Z"
            idComune:"063058"
            idNazione:"IT"
            identificativ: "REN0003-00017"
            indirizz: "Via Ignazio"
            isSedeLegale:false
            localita:null
            nome:"UNITA' LOCALE TEST RENTRI"
            progressivoRi:null
            provincia:"NAPOLI"
            siglaProvincia:"NA"
            stat: null
            utenteCreazione:"SCASSILLO IGNAZIO"
            via:"Via Ignazio"
          */

          this.datiProduttore = {
            identificativoSito: this.idUL,
            produttoreDenominazione: this.azienda.denominazione,
            produttoreCodiceFiscale: this.azienda.identificativo,
            produttoreVia: this.selectedUL[0].indirizzo ? this.selectedUL[0].indirizzo : this.selectedUL[0].via,
            produttoreCivico: this.selectedUL[0].civico,
            produttoreComune: this.selectedUL[0].comune,
            produttoreComuneIstat: this.selectedUL[0].idComune,
            produttoreSiglaProvincia: this.selectedUL[0].siglaProvincia,
            produttoreCap: null,
            produttorePaese: this.selectedUL[0].idNazione,


          }


          this.getFormulariElenco(this.idUL);


        } else {

          this.rentriService.getElencoFormulari().then(formulari => {
            if (formulari)
              this.elencoFormulariTbl = formulari
            this.rentriGrid.instance.refresh();
            this.selectedUL = null
          });
        }
        //this.productsStore.load();
      },
    };
  }

  changeFilter(ev, arrayStati, formulari) {

    this.elencoFormulariTbl = this.filterFirma(formulari, arrayStati);


  }

  filterFirma(formulari, arrayStati) {

    const filterFormulariFirma = formulari.filter(arrayFormulario => {
      let x = false
      arrayStati.forEach(stato => {

        if (arrayFormulario.statoFormulario == stato)
          x = true
      })

      return x


    });

    return filterFormulariFirma
  }

  filterToStato(formulari, stato) {
    const queryString = 'StatoFormulario=' + stato
    this.rentriService.getElencoFormulari(this.idUL, queryString).then(res => {
      this.elencoFormulariTbl = res
    })

    this.elencoFormulariTbl = formulari.filter(arrayFormulario => arrayFormulario.statoFormulario === stato)

  }


  menuFir(e, numeroFir) {


    this.openDMenu = true;
    const itemData = e.itemData

    switch (e.itemData.value) {
      case 'previewxPDF':
        this.previewxPDF(numeroFir)
        break;
      case 'downloadxPDF':
        this.downloadxPDF(numeroFir);

      case 'editFormulario':
        confirm('La funzione è in lavorazione, vuoi procedere lo stesso?', 'Attenzione!').then(res => {

          if (res) {
            this.editFormulario(numeroFir)
          }
        });

      default:
        break;
    }

  }

  previewxPDF(idFIR) {


    this.loader.show();
    this.embed = '';
    this.currentFirSelected = idFIR
    this.rentriService.statoFormuario(this.currentFirSelected).then(response => {

      this.firmaButtonOptions.text = response['statoFormulario'];
    })


    setTimeout(() => {
      this.rentriService.downloadPDF(idFIR).then(response => {

        if (response['codeMessage'] == -1) {

          this.loader.hide();
          alert(response['descrMessage'], 'Errore nel Download');

          return
        }

        let fileContent = response['content'];
        let mime = response['mime'];
        this.fileName = response['nomeFile'];


        let fileURL = 'data:' + mime + ';base64,' + fileContent;

        this.embed = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL)

        //'<embed src="data:' + mime + ';base64,' + fileContent + '" type="application/pdf" width="100%" height="600px" style="margin-top: 35px; border: 1px solid #ccc;" />'
        this.loader.hide();
        this.popupVisible = true;


      })
    }, 300);



  }

  downloadxPDF(idFIR) {

    this.loader.show();
    this.rentriService.downloadPDF(idFIR).then(response => {

      if (response['codeMessage'] == -1) {
        this.loader.hide();
        alert(response['descrMessage'], 'Errore nel Download')
        return
      }
      let fileContent = response['content'];
      let mime = response['mime'];
      let filename = response['nomeFile'];


      this.loader.hide();
      let link = document.createElement('a');
      link.href = 'data:' + mime + ';base64,' + fileContent;
      link.download = filename;
      link.click();

      //window.open(url);
    })

  }

  editFormulario(numeroFIR) {




    this.datiProduttore = null;

    this.rentriService.getDettaglioFormulario(numeroFIR).then(res => {

      if (res['statoFormulario'] == 'Completato' || res['statoFormulario'] == 'FirmaProduttore' || res['statoFormulario'] == 'FirmaDatiAccettazione' || res['statoFormulario'] == 'FirmaTrasportoPartenza' || res['statoFormulario'] == 'FirmaProduttoreTrasportatorePartenza' || res['statoFormulario'] == 'FirmaAllegato') {
        return
      }

      let produttoreDetentore = res['datiFormulario']['produttoreDetentore']

      let destinatario = res['datiFormulario']['destinatario'];

      let trasportatore = res['datiFormulario']['trasportatori'][0];
      let rifiuto = res['datiFormulario']['caratteristicheRifiuto'];

      let quantitaRifiuto = res['datiFormulario']['quantitaRifiuto']
      let datiTrasporto = res['datiTrasporto']



      this.datiProduttore = {
        identificativoSito: produttoreDetentore.identificativoSito,
        produttoreDenominazione: produttoreDetentore.denominazione,
        produttoreCodiceFiscale: produttoreDetentore.codiceFiscalePaese.codiceFiscale,
        produttoreVia: produttoreDetentore.indirizzo.via,
        produttoreCivico: produttoreDetentore.indirizzo.civico,
        produttoreComune: produttoreDetentore.indirizzo.citta,
        produttoreComuneIstat: produttoreDetentore.indirizzo.comuneIstat,
        produttoreSiglaProvincia: produttoreDetentore.indirizzo.siglaProvincia,
        produttoreCap: produttoreDetentore.indirizzo.cap,
        produttorePaese: produttoreDetentore.indirizzo.paese.id,

        destinatarioDenominazione: destinatario.denominazione,
        destinatarioCodiceFiscale: destinatario.codiceFiscalePaese.codiceFiscale,
        destinatarioVia: destinatario.indirizzo.via,
        destinatarioCivico: destinatario.indirizzo.civico,
        destinatarioCitta: destinatario.indirizzo.citta,
        destinatarioComune: destinatario.indirizzo.citta,
        destinatarioPaese: destinatario.indirizzo.paese.id,
        destinatarioCap: destinatario.indirizzo.cap,
        destinatarioSiglaProvincia: destinatario.indirizzo.siglaProvincia,
        destinatarioIstat: destinatario.indirizzo.comuneIstat,
        destinatarioAutorizzazioneNumero: destinatario.autorizzazioneRS.numero,
        destinatarioAutorizzazioneData: destinatario.autorizzazioneRS.data,

        trasportatoriDenominazione: trasportatore.denominazione,
        trasportatoriCodiceFiscale: trasportatore.codiceFiscalePaese.codiceFiscale,
        trasportatoriVia: trasportatore.indirizzo.via,
        trasportatoriCivico: trasportatore.indirizzo.civico,
        trasportatoriCitta: trasportatore.indirizzo.citta,
        trasportatoriComune: trasportatore.indirizzo.citta,
        trasportatoriPaese: trasportatore.indirizzo.paese.id,
        trasportatoriCap: trasportatore.indirizzo.cap,
        trasportatoriSiglaProvincia: trasportatore.indirizzo.siglaProvincia,
        trasportatoriIstat: trasportatore.indirizzo.comuneIstat,
        trasportatoriAutorizzazioneNumero: trasportatore.autorizzazioneAlbo.numero,
        trasportatoriAutorizzazioneData: trasportatore.autorizzazioneAlbo.data,

        rifiutoCodiceEer: rifiuto.codiceEer,
        descrizioneRifiuto: rifiuto.descrizioneRifiuto,
        caratteristicheChimicoFisiche: rifiuto.caratteristicheChimicoFisiche,
        classiPericolo: rifiuto.classiPericolo,
        statoFisico: rifiuto.statoFisico,
        numeroColli: rifiuto.numeroColli,
        tipoImballaggio: rifiuto.tipoImballaggio,
        destinazioneRifiuto: res['datiFormulario']['destinazioneRifiuto'],
        valore: quantitaRifiuto['quantita']['valore'],
        um: quantitaRifiuto['quantita']['um'],
        pesolordo: quantitaRifiuto['pesoLordo'],
        tara: quantitaRifiuto['tara'],
        verificareADestino: quantitaRifiuto['verificareADestino'],
        percorso: res['datiFormulario']['percorso'],
        normativaADR: res['datiFormulario']['normativaADR'],
        annotazioni: res['datiFormulario']['annotazioni'],





      }

      if (datiTrasporto.length > 0) {
        this.datiProduttore['datiTrasportoPartenzaConducenteNome'] = datiTrasporto[0]['conducente']['nome'],
          this.datiProduttore['datiTrasportoPartenzaConducenteCognome'] = datiTrasporto[0]['conducente']['cognome'],
          this.datiProduttore['datiTrasportoPartenzaTargaAutomezzo'] = datiTrasporto[0]['targaAutomezzo'],
          this.datiProduttore['datiTrasportoPartenzaTargaRimorchio'] = datiTrasporto[0]['targaRimorchio'],

          this.datiProduttore['datiTrasportoPartenzaDataInizioTrasporto'] = datiTrasporto[0]['dataInizioTrasporto'],
          this.datiProduttore['datiTrasportoPartenzaOraInizioTrasporto'] = datiTrasporto[0]['oraInizioTrasporto'],

          this.datiProduttore['datiTrasportoPartenzaAnnotazioni'] = datiTrasporto[0]['annotazioni']
      }

      this.popupVisibleForm = true;

      this.subjectCall = 'formularioForm';
      this.typeForm = 'tabbed';
      this.currentFirSelected = numeroFIR

      this.buttonCustom = [
        {
          location: "after",
          widget: "dxButton",
          locateInMenu: "never",
          stylingMode: 'text',
          text: 'Salva',
          icon: "glyphicon mdi mdi-content-save-outline",
          event: 'EditFormulario'

        },
      ]

      setTimeout(() => {
        let tabs = this.formulariForm.formEdit.instance.option('items')[0].tabs
        let formData = this.formulariForm.formData;


        tabs.forEach((tab, index) => {



          if (tab.disabled) {

            formData[index].disabled = false




          }



        })

        this.formulariForm.toolbarBottom = true;

        this.loader.hide()
      }, 300);


    })
  }


  buttonFirmaFormulario(ev, numeroFIR) {
    this.openDMenu = true;
    let idetificativoCurrentLogin = this.azienda.identificativo
    this.currentFirSelected = numeroFIR
    this.rentriService.statoFormuario(numeroFIR).then(response => {
      console.log(response)
      if (response['datiTrasporto'].length >= 1 && response['datiFormulario']['quantitaRifiuto']['quantita']['valore'] != '') {

        if (response['statoFormulario'] == 'FirmaProduttore') {
          let codiceFiscale = response['datiFormulario']['produttoreDetentore']['codiceFiscalePaese']['codiceFiscale'];

          if (codiceFiscale == idetificativoCurrentLogin) {
            let identificativo = 0 //this.azienda.identificativo;
            let tipoFirma = 'Produttore';
            this.rentriService.firmaFormulario(identificativo, tipoFirma, this.currentFirSelected).then(response => {
              if (response) {
                notify({
                  message: 'Formulario Firmato',
                  height: 45,
                  width: 150,
                  position: 'center right'

                }, 'success', 3000);

                this.hidePopup(response);
                this.destroyPreview(response)
                this.popupVisible = false;
                this.getFormulariElenco();
              }
            });
          } else {
            alert('Non hai i permessi per procedere con la Firma del Formulario', 'Attenzione! non sei il Produttore')
          }
        }


        if (response['statoFormulario'] == 'FirmaTrasportoPartenza') {


          let codiceFiscale = response['datiFormulario']['trasportatori'][0]['codiceFiscalePaese']['codiceFiscale'];
          if (codiceFiscale == idetificativoCurrentLogin) {
            let identificativo = 1 //this.azienda.identificativo;
            let tipoFirma = 'Trasportatore ';
            this.rentriService.firmaFormulario(identificativo, tipoFirma, this.currentFirSelected).then(response => {
              if (response) {
                notify({
                  message: 'Formulario Firmato',
                  height: 45,
                  width: 150,
                  position: 'center right'

                }, 'success', 3000);

                this.hidePopup(response);
                this.destroyPreview(response)
                this.popupVisible = false;
                this.getFormulariElenco();
              }
            });
          } else {
            alert('Non hai i permessi per procedere con la Firma del Formulario', 'Attenzione! non sei il Trasportatore');
          }

        }

        if (response['statoFormulario'] == 'FirmaProduttoreTrasportatorePartenza') {



          let codiceFiscaleTrasportatore = response['datiFormulario']['trasportatori'][0]['codiceFiscalePaese']['codiceFiscale'];
          let codiceFiscaleProduttore = response['datiFormulario']['produttoreDetentore']['codiceFiscalePaese']['codiceFiscale'];

          if (codiceFiscaleTrasportatore == idetificativoCurrentLogin || codiceFiscaleProduttore == idetificativoCurrentLogin) {
            let tipoFirma = ''
            if (codiceFiscaleTrasportatore == idetificativoCurrentLogin) {
              tipoFirma = 'Trasportatore'
            }
            if (codiceFiscaleProduttore == idetificativoCurrentLogin) {
              tipoFirma = 'Produttore'
            }
            if (codiceFiscaleTrasportatore == idetificativoCurrentLogin && codiceFiscaleProduttore == idetificativoCurrentLogin) {
              tipoFirma = 'ProduttoreTrasportatore'
            }
            let identificativo = 1 //this.azienda.identificativo;

            this.rentriService.firmaFormulario(identificativo, tipoFirma, this.currentFirSelected).then(response => {

              if (response) {
                notify({
                  message: 'Formulario Firmato',
                  height: 45,
                  width: 150,
                  position: 'center right'

                }, 'success', 3000);


                this.hidePopup(response);
                this.destroyPreview(response)
                this.popupVisible = false;
                this.getFormulariElenco();
              }
            });

          } else {

            alert('Non hai i permessi per procedere con la Firma del Formulario', 'Attenzione! Non sei il Produttore e Trasportatore');
          }
        }
        if (response['statoFormulario'] == 'FirmaDatiAccettazione') {
          let codiceFiscale = response['datiFormulario']['destinatario']['codiceFiscalePaese']['codiceFiscale'];
          if (codiceFiscale == idetificativoCurrentLogin) {
            let identificativo = 1 //this.azienda.identificativo;
            let tipoFirma = 'Destinatario';
            this.rentriService.firmaFormulario(identificativo, tipoFirma, this.currentFirSelected).then(response => {
              if (response) {
                notify({
                  message: 'Formulario Firmato',
                  height: 45,
                  width: 150,
                  position: 'center right'

                }, 'success', 3000);
                this.hidePopup(response);
                this.destroyPreview(response)
                this.popupVisible = false;
                this.getFormulariElenco();

              }
            });
          } else {
            alert('Non hai i permessi per procedere con la Firma del Formulario', 'Attenzione! non sei il Destinatario');
          }


        }




        if (response['statoFormulario'] == 'InserimentoDatiAccettazione') {
          let codiceFiscale = response['datiFormulario']['destinatario']['codiceFiscalePaese']['codiceFiscale'];
          if (codiceFiscale == idetificativoCurrentLogin) {
            let result = confirm("Vuoi procedere con l'inserimeto dei dati di Accettazione?", "Dati del destinatario mancanti");

            result.then((dialogResult) => {
              if (dialogResult) {
                this.destroyPreview(event);

                this.subjectCallDati = 'formulariFormDatiAccettazione';
                this.apicallDati = 'RentriOld/aggiungiDatiAccettazione';

                this.typeForm = "simpleForm"
                this.datijsonDati = {

                  denominazioneFirmatario: response['datiFormulario']['destinatario']['denominazione'],
                  identificativoFirmatario: response['datiFormulario']['destinatario']['codiceFiscalePaese']['codiceFiscale'],
                  tipoFirma: 'Destinatario'

                }
                this.widthPopup = 600
                this.heightPopup = 472
                this.heightFormSingleTab = 400;
                this.buttonCustomDati = [
                  {
                    location: "after",
                    stylingMode: 'text',
                    widget: "dxButton",
                    locateInMenu: "never",
                    text: 'Salva dati Accettazione',
                    icon: "glyphicon mdi mdi-content-save-outline",
                    event: 'SalvaDatiAccettazione'

                  },
                ];
                this.popupDatiTrasportoForm = true
              }

            })
          } else {
            alert('Non hai i permessi per procedere', 'Attenzione! non sei il Destinatario');
          }

        }

      }
      if (response['statoFormulario'] == 'InserimentoQuantita') {
        let codiceFiscaleProduttore = response['datiFormulario']['produttoreDetentore']['codiceFiscalePaese']['codiceFiscale'];
        let codiceFiscaleTrasportatore = response['datiFormulario']['trasportatori'][0]['codiceFiscalePaese']['codiceFiscale'];
        if (codiceFiscaleProduttore == idetificativoCurrentLogin || codiceFiscaleTrasportatore == idetificativoCurrentLogin) {
          let result = confirm("Vuoi procedere con l'inserimeto dei le quantità?", "Quantità del rifiuto mancanti");

          result.then((dialogResult) => {
            if (dialogResult) {
              this.destroyPreview(event);

              this.subjectCallDati = 'formulariFormDatiQuantita';
              this.apicallDati = 'RentriOld/aggiungiDatiQuantita';

              this.typeForm = "simpleForm"
              this.widthPopup = 600
              this.heightPopup = 400
              this.heightFormSingleTab = 328;


              let tipoFirma;
              let denominazioneFirmatario;
              let identificativoFirmatario
              if (codiceFiscaleProduttore == codiceFiscaleProduttore && codiceFiscaleTrasportatore == idetificativoCurrentLogin) {
                tipoFirma = 'ProduttoreTrasportatore',
                  denominazioneFirmatario = response['datiFormulario']['produttoreDetentore']['denominazione'];
                identificativoFirmatario = response['datiFormulario']['produttoreDetentore']['codiceFiscalePaese']['codiceFiscale']
              } else if (codiceFiscaleProduttore == idetificativoCurrentLogin) {
                tipoFirma = 'Produttore'
                denominazioneFirmatario = response['datiFormulario']['produttoreDetentore']['denominazione'];
                identificativoFirmatario = response['datiFormulario']['produttoreDetentore']['codiceFiscalePaese']['codiceFiscale']
              } else if (codiceFiscaleTrasportatore == idetificativoCurrentLogin) {
                tipoFirma = 'Trasportatore'
                denominazioneFirmatario = response['datiFormulario']['Trasportatori'][0]['denominazione'];
                identificativoFirmatario = response['datiFormulario']['Trasportatori'][0]['codiceFiscalePaese']['codiceFiscale']
              }

              this.datijsonDati = {

                denominazioneFirmatario: response['datiFormulario']['destinatario']['denominazione'],
                tipoFirma: tipoFirma,
                identificativoFirmatario: identificativoFirmatario

              }

              this.buttonCustomDati = [
                {
                  location: "after",
                  stylingMode: 'text',
                  widget: "dxButton",
                  locateInMenu: "never",
                  text: 'Salva quantità rifiuto',
                  icon: "glyphicon mdi mdi-content-save-outline",
                  event: 'SalvaQuantitaRifiuto'

                },
              ];
              this.popupDatiTrasportoForm = true
            }

          })
        }

      }

      if (response['statoFormulario'] == 'InserimentoQuantitaTrasportoPartenza') {
        let result = confirm("Vuoi procedere con l'inserimeto dei dati mancanti?", "Dati di trasporto e quantità mancanti");
        result.then((dialogResult) => {
          if (dialogResult) {


            this.subjectCallDati = 'formulariFormDatiTrasportoQuantita';
            this.apicallDati = 'RentriOld/aggiungiDatiTrasporto';
            this.heightFormSingleTab = 528;
            this.heightPopup = 600;
            this.widthPopup = 1200;
            this.typeForm = "simpleForm";
            this.nCol = 2
            this.datijsonDati = {

              denominazioneFirmatario: response['datiFormulario']['trasportatori'][0]['denominazione'],
              identificativoFirmatario: response['datiFormulario']['trasportatori'][0]['codiceFiscalePaese']['codiceFiscale'],

            }




            this.buttonCustomDati = [
              {
                location: "after",
                stylingMode: "text",
                widget: "dxButton",
                locateInMenu: "never",
                text: 'Salva dati Trasporto',
                icon: "glyphicon mdi mdi-content-save-outline",
                event: 'SalvaDatiTrasportoQuantita'

              },
            ]

            this.popupDatiTrasportoForm = true
          }

        });
      }


      if (response['statoFormulario'] == 'InserimentoTrasportoPartenza') {
        let result = confirm("Vuoi procedere con l'inserimeto dei dati di Trasporto?", "Dati di trasporto mancanti");
        result.then((dialogResult) => {
          if (dialogResult) {


            this.subjectCallDati = 'formulariFormDatiTrasporto';
            this.apicallDati = 'RentriOld/aggiungiDatiTrasporto';

            this.heightFormSingleTab = 528;
            this.heightPopup = 600;
            this.widthPopup = 1000;
            this.typeForm = "simpleForm";
            this.nCol = 1
            this.datijsonDati = {

              denominazioneFirmatario: response['datiFormulario']['trasportatori'][0]['denominazione'],
              identificativoFirmatario: response['datiFormulario']['trasportatori'][0]['codiceFiscalePaese']['codiceFiscale'],
              tipoFirma: 'Trasportatore'

            }




            this.buttonCustomDati = [
              {
                location: "after",
                stylingMode: "text",
                widget: "dxButton",
                locateInMenu: "never",
                text: 'Salva dati Trasporto',
                icon: "glyphicon mdi mdi-content-save-outline",
                event: 'SalvaDatiTrasporto'

              },
            ]

            this.popupDatiTrasportoForm = true
          } else {

          }

        });
      }





    })
  }

  rederstato(statoString: string) {
    if (statoString != undefined) {
      let stato = this.stati.filter(stato => stato.stato == statoString)
      if (stato[0].stato != undefined) {

        //let icons = stato[0].icons.split('|');

        let html = statoString.replace(/([A-Z])/g, ' $1').trim();

        /*icons.forEach((element, key) => {
          if (key > 0) {
           // html += '<sup><i class="mdi ' + element + '"></i></sup>';
          } else {
          //  html += '<i class="mdi ' + element + '"></i>'
          }
  
        });*/



        return html
      }


    }
  }
  rederstatoDescrizione(statoString: string) {
    if (statoString != undefined) {

      let descrStato = this.stati.filter(stato => stato.stato == statoString)

      if (descrStato != undefined) {
        let toolTips = descrStato[0].descrizione;


        return toolTips
      }


    }
  }


  destroyPreview(e) {
    console.log(e)
    this.embed = '';
    this.popupVisible = false;
  }




  statiFormulario(formulari) {


    let v = removeDuplicates(formulari)
    console.log(v)
    v.forEach(form => {
      let statoString = form.statoFormulario;

      //InserimentoTrasportoPartenza

      this.stati.push({
        stato: form.statoFormulario,
        statoDesc: getCorrectDescStato(statoString), //statoString.replace(/([A-Z])/g, ' $1').trim(),
        descrizione: ''
      })

    })


    function getCorrectDescStato(stato) {
      let statoDesc = ''
      switch (stato) {
        case 'InserimentoTrasportoPartenza':
          statoDesc = 'in attesa dei dati di Trasporto'
          break;
        case 'FirmaProduttore':
          statoDesc = 'In attesa di firma del produttore'
          break;
        case 'InserimentoDatiAccettazione':
          statoDesc = 'In attesa dei dati di conferma del destinatario'
          break;
        case 'FirmaDatiAccettazione':
          statoDesc = 'In attesa di firma dal destinatario'
          break;
        case 'FirmaTrasportoPartenza':
          statoDesc = 'In attesa della firma del trasportatore'
          break;
        case 'FirmaTrasportoSuccessivo':
          statoDesc = 'In attesa della firma del trasportatore successivo'
          break;
        case 'FirmaProduttoreTrasportatorePartenza':
          statoDesc = 'In attesa della firma del produttore o trasportatore'
          break;
        case 'FirmaAnnotazioni':
          statoDesc = 'In attesa di firma delle annotazioni'
          break;
        case 'FirmaAllegato':
          statoDesc = "In attesa di firma dell'allegato"
          break;
        default:
          statoDesc = stato
      }
      return statoDesc

    }


    function removeDuplicates(stati) {
      const uniqueValuesSet = new Set();
      const filteredArr = stati.filter((obj) => {
        // check if name property value is already in the set
        const isPresentInSet = uniqueValuesSet.has(obj.statoFormulario);

        // add name property value to Set
        uniqueValuesSet.add(obj.statoFormulario);

        return !isPresentInSet;
      });
      return filteredArr;
    }
  }

  selectionChanged(e) {

    console.log(e)
    e.component.collapseAll(-1);
    e.component.expandRow(e.currentSelectedRowKeys[0]);
  }

  rowSelection(e) {

    console.log('rowSelection', e);

    if (this.openDMenu) {
      return
    }
    this.loader.show()
    let numeroFIR = e.data.numeroFIR

    this.previewxPDF(numeroFIR);
    return




  }

  renderDetail(formulario, keys = '') {

    console.log(formulario)

    Object.keys(formulario).forEach((key, i) => {
      console.log(i)
      let value = formulario[key]
      if (value != null) {

        this.detailFormulario += '<div class="section-detail">'
        if (typeof value == 'object' && value != null) {
          if (key != '0') {

            this.detailFormulario += '<div class="dx-fieldset-header">' + key + '</div>'
          }

          this.renderDetail(value, key)

        } else {

          this.detailFormulario += '<div class="field">'
          this.detailFormulario += '<span class="label"><b>' + key + '</b></span> :  <span class="value">' + value + '</span>'
          //this.detailFormulario += '<div class="static">' + value + '</div>'
          this.detailFormulario += '</div>'


        }


        this.detailFormulario += '</div>'
      }

    });


  }

  /**RECUPERA FORMULARI**/

  getFormulariElenco(ul = '') {

    this.rentriService.getElencoFormulari(ul).then(formulari => {
      this.elencoFormulari = formulari
      this.elencoFormulariTbl = this.elencoFormulari;
      ///this.renderFilterButton(formulari)
      this.statiFormulario(formulari);

    });
  }


  /**EVENTI **/
  tabClick(event) {

    const navigationParams = {
      ...this.queryParams,

      componentTemplate: 'griglia',
      denominazioneAzienda: this.denominazioneAzienda
    }
    this.router.navigate([event.itemData.path],
      {
        queryParams: navigationParams,
        skipLocationChange: false,
        replaceUrl: false
      })

    //console.log(event.itemData)
  }

  return(ev) {
    this.router.navigateByUrl(this.returnUrl, {
      skipLocationChange: true,
      replaceUrl: false
    });
  }


  submitFormulario(data) {

    console.log('submitFormulario', data)
    if (data.step == 0) {

      this.datiFormulario = data;

      if (data.isValid) {
        this.formulariForm.clickStep(data.action)
      }
    }

    if (data.step == 1) {
      this.datiFormulario = data;
      if (data.isValid) {
        this.formulariForm.clickStep(data.action)
      }
    }

    if (data.step == 2) {
      if (data.isValid) {

        this.datiFormulario = data;
        this.formulariForm.clickStep(data.action)
      }
    }

    if (data.step == 3) {

      this.datiFormulario = data
      this.emittendButtonPush('Salta');
    }


    if (data.step == 4) {



      if (!data.isValid) {
        return
      }


      this.datiFormulario = data;


      confirm("Vuoi inviare il formulario?", "Conferma").then(confirm => {
        if (confirm) {
          this.loader.show();
          const js = this.createJson();

          this.rentriService.salvaFormulario(js).then(resp => {



            if (resp) {
              //qui
              this.loader.hide();

              const navigationParams = {
                ...this.queryParams,
                infoAzienda: JSON.stringify(this.azienda),
                componentTemplate: 'griglia',

              }
              //const navigationParams = {...this.queryParmas, infoAzienda: JSON.stringify(this.infoAzienda[0])}

              this.router.navigate(
                ['main/rentri/formulari'],
                {
                  queryParams: navigationParams,
                  skipLocationChange: true,
                  replaceUrl: false
                }
              )



            }

            return
          })

        }


      })



    }



  }
  createJson() {



    let newJson: FORMULARIO = {

      identificativoSito: this.datiFormulario['identificativoSito'],
      datiFormulario: {

        dataEmissione: this.datiFormulario['dataEmissione'],
        produttoreDetentore: {
          identificativoSito: this.datiFormulario['identificativoSito'],
          contatto: null,
          luogoProduzione: null,
          autorizzazioneRS: null
        },

        trasportatori: [{
          idTrasportatore: 1,
          codiceFiscalePaese: {
            paeseId: "IT",
            codiceFiscale: this.datiFormulario['trasportatoriCodiceFiscale']
          },
          denominazione: this.datiFormulario["trasportatoriDenominazione"],
          indirizzo: {
            siglaProvincia: this.datiFormulario["trasportatoriSiglaProvincia"],
            provincia: this.datiFormulario["trasportatoriProvincia"],
            paese: {
              id: this.datiFormulario["trasportatoriPaese"],
              nome: this.datiFormulario["trasportatoriPaeseDescrizione"]
            },
            cap: this.datiFormulario["trasportatoriCap"],
            citta: this.datiFormulario["trasportatoriProvincia"],
            localita: this.datiFormulario["trasportatoriComune"],
            via: this.datiFormulario["trasportatoriVia"],
            civico: this.datiFormulario["trasportatoriCivico"],
            paeseId: this.datiFormulario["trasportatoriPaese"],
            comuneIstat: this.datiFormulario["trasportatoriIstat"]
          },
          /*contatto: {
            nome: this.datiFormulario["trasportatoriContattoNome"],
            cognome: this.datiFormulario["trasportatoriContattoCognome"],
            telefono: this.datiFormulario["trasportatoriContattoTelefono"],
            email: this.datiFormulario["trasportatoriContattoEmail"]
          },*/
          autorizzazioneAlbo: {
            numeroIscrizione: this.datiFormulario["trasportatoriAutorizzazioneNumero"],
            dataIscrizione: this.datiFormulario["trasportatoriAutorizzazioneData"]
          }
        }],
        destinatario: {
          indirizzo: {
            siglaProvincia: this.datiFormulario["destinatarioSiglaProvincia"],
            provincia: this.datiFormulario["destinatarioProvincia"],
            paese: {
              id: this.datiFormulario["destinatarioPaese"],
              nome: this.datiFormulario["destinatarioPaeseDescrizione"]

            },
            cap: this.datiFormulario["destinatarioCap"],
            citta: this.datiFormulario["destinatarioProvincia"],
            localita: this.datiFormulario["destinatarioCitta"],
            via: this.datiFormulario["destinatarioVia"],
            civico: this.datiFormulario["destinatarioCivico"],
            paeseId: this.datiFormulario["destinatarioPaese"],
            comuneIstat: this.datiFormulario["destinatarioIstat"]
          },
          codiceFiscalePaese: {
            paeseId: this.datiFormulario["destinatarioPaese"],
            codiceFiscale: this.datiFormulario["destinatarioCodiceFiscale"]
          },
          denominazione: this.datiFormulario["destinatarioDenominazione"],
          /*contatto: {
            nome: this.datiFormulario["destinatarioContattoNome"],
            cognome: this.datiFormulario["destinatarioContattoCognome"],
            telefono: this.datiFormulario["destinatarioContattoTelefono"],
            email: this.datiFormulario["destinatarioContattoEmail"]
          },*/
          autorizzazioneRS: {
            numero: this.datiFormulario["destinatarioAutorizzazioneNumero"],
            data: this.datiFormulario["destinatarioAutorizzazioneData"]
          }
        },
        dataFirma: "0001-01-01T00:00:00",
        denominazioneFirmatario: null,
        identificativoFirmatario: null,
        intermediari: null,
        caratteristicheRifiuto: {
          codiceEer: this.datiFormulario["rifiutoCodiceEer"],
          statoFisico: this.datiFormulario["statoFisico"],//Per Ricavare il codice dello stato fisico SP,SNP ecc..
          descrizioneRifiuto: this.datiFormulario['descrizioneRifiuto'] ? this.datiFormulario['descrizioneRifiuto'] : null,
          caratteristicheChimicoFisiche: this.datiFormulario["caratteristicheChimicoFisiche"],
          classiPericolo: this.datiFormulario["classiPericolo"],
          numeroColli: this.datiFormulario["numeroColli"],
          tipoImballaggio: this.datiFormulario["tipoImballaggio"]
        },
        destinazioneRifiuto: this.datiFormulario["destinazioneRifiuto"],

        percorso: this.datiFormulario["percorso"],
        normativaADR: {
          numeroONU: this.datiFormulario["numeroONU"],
          classeADR: this.datiFormulario["classeADR"],
          gruppoImballaggio: this.datiFormulario["gruppoImballaggio"],
          noteADR: this.datiFormulario["noteADR"]
        },
        annotazioni: this.datiFormulario["datiRifiutoAnnotazioni"]
      }



    }

    if (this.datiFormulario["um"] && this.datiFormulario["valore"]) {
      newJson['datiFormulario']['quantitaRifiuto'] = {
        quantita: {
          um: this.datiFormulario["um"],
          valore: this.datiFormulario["valore"]
        },
        tara: this.datiFormulario["tara"],
        pesoLordo: this.datiFormulario["pesoLordo"],
        verificareADestino: this.datiFormulario["verificareADestino"]
      }
    } else {
      newJson['datiFormulario']['quantitaRifiuto'] = null

    }
    if (this.datiFormulario["datiTrasportoPartenzaConducenteNome"] && this.datiFormulario["datiTrasportoPartenzaConducenteCognome"]) {
      let oraInizioTrasporto

      if (this.datiFormulario["datiTrasportoPartenzaOraInizioTrasporto"] instanceof Date) {
        oraInizioTrasporto = this.datiFormulario["datiTrasportoPartenzaOraInizioTrasporto"].toLocaleTimeString()
      } else {
        oraInizioTrasporto = this.datiFormulario["datiTrasportoPartenzaOraInizioTrasporto"]
      }

      newJson['datiTrasportoPartenza'] = {
        idTrasportatore: 1,
        conducente: {
          nome: this.datiFormulario["datiTrasportoPartenzaConducenteNome"],
          cognome: this.datiFormulario["datiTrasportoPartenzaConducenteCognome"]
        },
        targaAutomezzo: this.datiFormulario["datiTrasportoPartenzaTargaAutomezzo"],
        targaRimorchio: this.datiFormulario["datiTrasportoPartenzaTargaRimorchio"],
        dataInizioTrasporto: this.datiFormulario["datiTrasportoPartenzaDataInizioTrasporto"],
        oraInizioTrasporto: oraInizioTrasporto,
        annotazioni: this.datiFormulario["datiTrasportoPartenzaAnnotazioni"]
      }
    } else {
      newJson['datiTrasportoPartenza'] = null
    }


    console.log(newJson)
    /*  let dataInizioTrasporto = Date();
      if(data.datiTrasportoPartenzaDataInizioTrasporto){
        dataInizioTrasporto = data.datiTrasportoPartenzaDataInizioTrasporto.toJSON();
      }
   
      let oraInizioTrasporto = new Date()
   
      if(data.datiTrasportoPartenzaOraInizioTrasporto){
        oraInizioTrasporto = data.datiTrasportoPartenzaOraInizioTrasporto.toTimeString()
      }*/
    function getFirstLetters(str) {
      const firstLetters = str
        .split(' ')
        .map(word => word[0])
        .join('');

      return firstLetters.toUpperCase();
    }




    return newJson
  }

  hidePopup($event) {
    this.datiFormulario = [];
    this.datiProduttore = [];
    this.datijsonDati = [];
    this.filterKeyDati = '';
    this.apicallDati = '';
    this.subjectCallDati = '';
    this.typeForm = '';
    this.buttonCustomDati = null;
    this.currentFirSelected = ''
    this.widthPopup = null;
    this.heightPopup = null;
    this.heightFormSingleTab = null

    this.popupDatiTrasportoForm = false

    //this.rentriGrid.instance.refresh()
    //this.formulariForm.formEdit.instance.resetValues()
    //this.formulariForm.formEdit.instance._refresh()
    //this.datiTrasporto.formEdit.instance.resetValues()
    //this.datiTrasporto.formEdit.instance.repaint()
  }

  showPopUp(e) {
    this.firmaButtonOptions;
    e.component.content().parentNode.classList.add("formEditPopup"); //add class to overlay content
    e.component.content().classList.add("formEditPopupContet"); //add class to content
    e.component.content().classList.add("bg-grey"); //add class to content
  }



  emittendButtonPush(event) {

    console.log(event)
    if (event.evento == 'copiaDatiAziendaProduttore') {

      if (event.event.value) {
        let indirizzo = this.selectedUL[0].indirizzo ? this.selectedUL[0].indirizzo : this.selectedUL[0].via
        this.formulariForm.formEdit.instance.updateData('produttoreDenominazione', this.azienda.denominazione);
        this.formulariForm.formEdit.instance.updateData('produttoreCodiceFiscale', this.azienda.identificativo);
        //this.formulariForm.formEdit.instance.updateData('destinatarioContattoEmail', this.azienda.pec);
        this.formulariForm.formEdit.instance.updateData('produttoreVia', indirizzo);
        this.formulariForm.formEdit.instance.updateData('produttoreCivico', this.selectedUL[0].civico);
        this.formulariForm.formEdit.instance.updateData('produttoreCitta', this.selectedUL[0].localita);
        this.formulariForm.formEdit.instance.updateData('produttoreComune', this.selectedUL[0].comune);
        this.formulariForm.formEdit.instance.updateData('produttoreoPaese', this.selectedUL[0].idNazione);
        //this.formulariForm.formEdit.instance.updateData('destinatarioCap', this.azienda.capSl);
        this.formulariForm.formEdit.instance.updateData('produttoreSiglaProvincia', this.selectedUL[0].siglaProvincia);
        this.formulariForm.formEdit.instance.updateData('produttoreIstat', this.selectedUL[0].idComune);
      } else {
        this.formulariForm.formEdit.instance.updateData('produttoreDenominazione', '');
        this.formulariForm.formEdit.instance.updateData('produttoreCodiceFiscale', '');
        this.formulariForm.formEdit.instance.updateData('produttoreContattoEmail', '');
        this.formulariForm.formEdit.instance.updateData('produttoreVia', '');
        this.formulariForm.formEdit.instance.updateData('produttoreCivico', '');
        this.formulariForm.formEdit.instance.updateData('produttoreCitta', '');
        this.formulariForm.formEdit.instance.updateData('produttoreComune', '');
        this.formulariForm.formEdit.instance.updateData('produttorePaese', '');
        this.formulariForm.formEdit.instance.updateData('produttoreCap', '');
        this.formulariForm.formEdit.instance.updateData('produttoreSiglaProvincia', '');
        this.formulariForm.formEdit.instance.updateData('produttoreIstat', '');
      }

    }



    if (event.evento == 'copiaDatiAziendaDestinatario') {

      if (event.event.value) {
        let indirizzo = this.selectedUL[0].indirizzo ? this.selectedUL[0].indirizzo : this.selectedUL[0].via
        this.formulariForm.formEdit.instance.updateData('destinatarioDenominazione', this.azienda.denominazione);
        this.formulariForm.formEdit.instance.updateData('destinatarioCodiceFiscale', this.azienda.identificativo);
        //this.formulariForm.formEdit.instance.updateData('destinatarioContattoEmail', this.azienda.pec);
        this.formulariForm.formEdit.instance.updateData('destinatarioVia', indirizzo);
        this.formulariForm.formEdit.instance.updateData('destinatarioCivico', this.selectedUL[0].civico);
        this.formulariForm.formEdit.instance.updateData('destinatarioCitta', this.selectedUL[0].localita);
        this.formulariForm.formEdit.instance.updateData('destinatarioComune', this.selectedUL[0].comune);
        this.formulariForm.formEdit.instance.updateData('destinatarioPaese', this.selectedUL[0].idNazione);
        //this.formulariForm.formEdit.instance.updateData('destinatarioCap', this.azienda.capSl);
        this.formulariForm.formEdit.instance.updateData('destinatarioSiglaProvincia', this.selectedUL[0].siglaProvincia);
        this.formulariForm.formEdit.instance.updateData('destinatarioIstat', this.selectedUL[0].idComune);
      } else {
        this.formulariForm.formEdit.instance.updateData('destinatarioDenominazione', '');
        this.formulariForm.formEdit.instance.updateData('destinatarioCodiceFiscale', '');
        this.formulariForm.formEdit.instance.updateData('destinatarioContattoEmail', '');
        this.formulariForm.formEdit.instance.updateData('destinatarioVia', '');
        this.formulariForm.formEdit.instance.updateData('destinatarioCivico', '');
        this.formulariForm.formEdit.instance.updateData('destinatarioCitta', '');
        this.formulariForm.formEdit.instance.updateData('destinatarioComune', '');
        this.formulariForm.formEdit.instance.updateData('destinatarioPaese', '');
        this.formulariForm.formEdit.instance.updateData('destinatarioCap', '');
        this.formulariForm.formEdit.instance.updateData('destinatarioSiglaProvincia', '');
        this.formulariForm.formEdit.instance.updateData('destinatarioIstat', '');
      }





    }

    if (event.evento == 'copiaDatiAziendaTrasportatore') {


      if (event.event.value) {
        let indirizzo = this.selectedUL[0].indirizzo ? this.selectedUL[0].indirizzo : this.selectedUL[0].via
        this.formulariForm.formEdit.instance.updateData('trasportatoriDenominazione', this.azienda.denominazione);
        this.formulariForm.formEdit.instance.updateData('trasportatoriCodiceFiscale', this.azienda.identificativo);
        //this.formulariForm.formEdit.instance.updateData('trasportatoriContattoEmail', this.azienda.pec);
        this.formulariForm.formEdit.instance.updateData('trasportatoriVia', indirizzo);
        this.formulariForm.formEdit.instance.updateData('trasportatoriCivico', this.selectedUL[0].civico);
        this.formulariForm.formEdit.instance.updateData('trasportatoriCitta', this.selectedUL[0].localita);
        this.formulariForm.formEdit.instance.updateData('trasportatoriComune', this.selectedUL[0].comune);
        this.formulariForm.formEdit.instance.updateData('trasportatoriPaese', this.selectedUL[0].idNazione);
        //this.formulariForm.formEdit.instance.updateData('trasportatoriCap', this.azienda.capSl);
        this.formulariForm.formEdit.instance.updateData('trasportatoriSiglaProvincia', this.selectedUL[0].siglaProvincia);
        this.formulariForm.formEdit.instance.updateData('trasportatoriIstat', this.selectedUL[0].idComune);
      } else {
        this.formulariForm.formEdit.instance.updateData('trasportatoriDenominazione', '');
        this.formulariForm.formEdit.instance.updateData('trasportatoriCodiceFiscale', '');
        this.formulariForm.formEdit.instance.updateData('trasportatoriContattoEmail', '');
        this.formulariForm.formEdit.instance.updateData('trasportatoriVia', '');
        this.formulariForm.formEdit.instance.updateData('trasportatoriCivico', '');
        this.formulariForm.formEdit.instance.updateData('trasportatoriCitta', '');
        this.formulariForm.formEdit.instance.updateData('trasportatoriComune', '');
        this.formulariForm.formEdit.instance.updateData('trasportatoriPaese', '');
        this.formulariForm.formEdit.instance.updateData('trasportatoriCap', '');
        this.formulariForm.formEdit.instance.updateData('trasportatoriSiglaProvincia', '');
        this.formulariForm.formEdit.instance.updateData('trasportatoriIstat', '');
      }





    }

    if (event.name == 'infoContattoSede') {

      this._overlaySidePanelService.setTitle('Elenco contatti Sede');
      this._overlaySidePanelService.setContent(ContattiComponent);
      this._overlaySideFormService.setToolBarVisible(true)
      this._overlaySideFormService.setHelp('Contatti.html')
      this._overlaySideFormService.setPopupWidth(800);
      this._overlaySideFormService.setPopupHeight(500);

      let data = [
        {
          idTabRif: this.idSedeSelected,
          nomeTabRif: 'sedi',
          destComponent: 'FormulariComponent',
          traceMessage: 'FormulariComponent',

        }
      ]
      this._overlaySidePanelService.sendDataToComponent(data);

      this._overlaySidePanelService.show();


      this.messageFromComponent(event.campo)

    }



    if (event.event == 'Salta') {


      this.formulariForm.clickStep('saltaTab')
    }

    if (event == 'SalvaDatiTrasporto') {
      this.loader.show();
      let form = this.datiTrasporto.formEdit
      let validate = form.instance.validate()
      if (validate) {
        const formData = form.instance.option("formData");

        let numeroFir = this.currentFirSelected

        let jsonDatiTrasportpPartenza: DATITRASPORTOPARTENZA = {

          idTrasportatore: 1,
          conducente: {
            nome: formData["datiTrasportoPartenzaConducenteNome"],
            cognome: formData["datiTrasportoPartenzaConducenteCognome"]
          },
          targaAutomezzo: formData["datiTrasportoPartenzaTargaAutomezzo"],
          targaRimorchio: formData["datiTrasportoPartenzaTargaRimorchio"],
          dataInizioTrasporto: formData["datiTrasportoPartenzaDataInizioTrasporto"],
          oraInizioTrasporto: formData["datiTrasportoPartenzaOraInizioTrasporto"].toLocaleTimeString(),
          annotazioni: formData["datiTrasportoPartenzaAnnotazioni"]
        }
        this.rentriService.aggiungiDatiTrasporto(jsonDatiTrasportpPartenza, numeroFir, 1).then(response => {

          console.log(response['codeMessage'])

          if (response['codeMessage'] != -1) {

            this.loader.hide();

            //this.firmaFormulario(formData)

            this.hidePopup(response);
            this.getFormulariElenco();
          }
        })
      }
      //alert('salva dati trasporto','salva')
    }
    /*********************************** */
    if (event == 'SalvaDatiTrasportoQuantita') {

      this.ayncSaved()

    }

    if (event == "SalvaDatiAccettazione") {
      this.loader.show()
      let form = this.datiTrasporto.formEdit

      let validate = form.instance.validate();
      const timeElapsed = Date.now();
      const today = new Date(timeElapsed);


      if (validate) {
        let numeroFir = this.currentFirSelected;
        const formData = form.instance.option("formData");
        let jsonDatiAccettazione: DATIACCETTAZIONE = {

          accettazioneCompleta: formData["accettazioneCompleta"],
          quantitaAccettata: {
            valore: formData["quantitaAccettataValore"] != '' ? formData["quantitaAccettataValore"] : 0,
            um: formData["quantitaAccettataUm"]
          },
          motivazioniRespingimento: formData["motivazioniRespingimento"],
          dataAccettazione: formData["dataAccettazione"],
          oraAccettazione: formData["oraAccettazione"].toLocaleTimeString(),
          annotazioni: formData["annotazioni"]
        }
        this.rentriService.aggiungiDatiAccettazione(jsonDatiAccettazione, numeroFir).then(response => {
          if (response['codeMessage'] != -1) {
            this.loader.hide()
            let result = confirm("Dati Inseriti, Vuoi procedere con la firma?", "Dati Accettazione Inseriti");

            result.then((dialogResult) => {
              if (dialogResult) {
                this.firmaFormulario(formData)


              }
              this.hidePopup(response);
              this.getFormulariElenco();


            })
          }
        })
      }
    }

    if (event == "SalvaQuantitaRifiuto") {
      this.loader.show();
      let form = this.datiTrasporto.formEdit
      let validate = form.instance.validate();


      if (validate) {
        let numeroFir = this.currentFirSelected;
        const formData = form.instance.option("formData");
        let jsonDatiQuantita = {


          quantita: {
            um: formData['um'],
            valore: formData['valore']
          },
          tara: formData['tara'],
          pesoLordo: formData['pesolordo'],
          verificareADestino: formData['verificareADestino']



        }

        this.rentriService.aggiungiDatiQuantita(jsonDatiQuantita, numeroFir).then(response => {
          if (response['codeMessage'] != -1) {
            this.loader.hide();
            let result = confirm("Dati Inseriti, Vuoi procedere con la firma?", "Quantità rifiuti Inserita");


            result.then((dialogResult) => {
              if (dialogResult) {
                this.firmaFormulario(formData)
              }
              this.hidePopup(response);
              this.getFormulariElenco();


            })
          }
        })
      }
    }

    if (event == 'EditFormulario') {
      const form = this.formulariForm.formEdit.instance;
      const validate = form.validate();
      if (validate.isValid) {
        this.loader.show()
        this.datiFormulario = this.formulariForm.formEdit.instance.option("formData")

        const js = this.createJson();
        this.rentriService.salvaFormularioModificato(js, this.currentFirSelected).then(res => {
          this.loader.hide();
          this.hidePopup(res)
        })
      }


    }
  }

  firmaFormulario(formData) {
    let codiceFiscale = formData["identificativoFirmatario"];
    if (codiceFiscale == this.azienda.identificativo) {
      let identificativo = 1 //formData['identificativoFirmatario'] //this.azienda.identificativo;
      let tipoFirma = formData["tipoFirma"];
      this.rentriService.firmaFormulario(identificativo, tipoFirma, this.currentFirSelected).then(res => {

        notify({
          message: 'Formulario Firmato',
          height: 45,
          width: 150,
          position: 'center right'

        }, 'success', 3000);
      });
    } else {
      alert('Non hai i permessi per procedere con la Firma del Formulario', 'Attenzione!');

    }
  }


  async ayncSaved() {
    this.loader.show();
    let form = this.datiTrasporto.formEdit
    let validate = form.instance.validate()

    if (validate) {

      let res = false
      const formData = form.instance.option("formData");

      let numeroFir = this.currentFirSelected

      let jsonDatiTrasportpPartenza: DATITRASPORTOPARTENZA = {

        idTrasportatore: 1,
        conducente: {
          nome: formData["datiTrasportoPartenzaConducenteNome"],
          cognome: formData["datiTrasportoPartenzaConducenteCognome"]
        },
        targaAutomezzo: formData["datiTrasportoPartenzaTargaAutomezzo"],
        targaRimorchio: formData["datiTrasportoPartenzaTargaRimorchio"],
        dataInizioTrasporto: formData["datiTrasportoPartenzaDataInizioTrasporto"],
        oraInizioTrasporto: formData["datiTrasportoPartenzaOraInizioTrasporto"].toLocaleTimeString(),
        annotazioni: formData["datiTrasportoPartenzaAnnotazioni"]
      }

      await this.rentriService.aggiungiDatiTrasporto(jsonDatiTrasportpPartenza, numeroFir, 1).then(response => {

        console.log(response)

        if (response['codeMessage'] == -1) {

          return
        }
      })

      let jsonDatiQuantita = {


        quantita: {
          um: formData['um'],
          valore: formData['valore']
        },
        tara: formData['tara'],
        pesoLordo: formData['pesolordo'],
        verificareADestino: formData['verificareADestino']



      }

      await this.rentriService.aggiungiDatiQuantita(jsonDatiQuantita, numeroFir).then(response => {
        if (response['codeMessage'] != -1) {
          this.loader.hide();
          this.hidePopup(response);
          this.getFormulariElenco();

        } else {
          return
        }
      })
    }
  }
  messageFromComponent(campo) {
    this.userComponentService.castMessage.subscribe((message: messagefromComponent) => {

      if (message.destComponent == 'FormulariComponent' && message.traceMessage == 'FormulariComponent') {

        this._overlaySidePanelService.close();
        console.log(message.Data);

        if (message.Data) {
          let newItem
          let related = campo.related
          let rel = message.Data
          related.forEach((values, key) => {
            let arrayValue = values.split('|')
            if (arrayValue.length > 1) {
              //newItem = {...this.datiFormulario, [arrayValue[1]]: rel[arrayValue[0]] };
              this.formulariForm.formEdit.instance.updateData(arrayValue[1], rel[arrayValue[0]]);
            } else {

              //newItem = {...this.datiFormulario, [values]: rel[values] };

              this.formulariForm.formEdit.instance.updateData(values, rel[values]);
            }

            //this.datiFormulario = newItem

            //console.log('datiFormulario', this.datiFormulario);


          })
          this.userComponentService.destroyMessage()
          /*
          
          //this.formulariForm.formEdit.instance.updateData('trasportatoriContattoEmail', this.azienda.pec);
          this.formulariForm.formEdit.instance.updateData('trasportatoriVia', );
          this.formulariForm.formEdit.instance.updateData('trasportatoriCivico', this.selectedUL[0].civico);
          this.formulariForm.formEdit.instance.updateData('trasportatoriCitta', this.selectedUL[0].localita);
          this.formulariForm.formEdit.instance.updateData('trasportatoriComune', this.selectedUL[0].comune);
          this.formulariForm.formEdit.instance.updateData('trasportatoriPaese', this.selectedUL[0].idNazione);
          //this.formulariForm.formEdit.instance.updateData('trasportatoriCap', this.azienda.capSl);
          this.formulariForm.formEdit.instance.updateData('trasportatoriSiglaProvincia', this.selectedUL[0].siglaProvincia);
          this.formulariForm.formEdit.instance.updateData('trasportatoriIstat', this.selectedUL[0].idComune);*/

          /*  this.datiFormulario={...this.datiFormulario,
 
 
 
           }
  */
        }


      }
    })
  }
}  